import { z } from 'zod';
import { IAsset } from './IAsset';
import { IAssetCategoryId } from './IAssetCategory';
import { AssetLocationSchema, IAssetLocation } from './IAssetLocation';
import { IAssetTypeId } from './IAssetType';
import { GenericAssetSchema } from './IGenericAsset';

export const CashAssetVersion = {
  Initial: 1,
} as const;

export type CashAssetVersion =
  (typeof CashAssetVersion)[keyof typeof CashAssetVersion];

export function getEmptyCashAsset(idAsset: number): ICashAsset {
  return {
    idAsset,
    idAssetType: IAssetTypeId.Cash,
    idAssetCategory: IAssetCategoryId.PersonalProperty,
    Version: CashAssetVersion.Initial,
    data: {
      amount: 0,
      assetLocation: IAssetLocation.Domestic,
      notes: '',
    },
  };
}

export function isCashAsset(asset: IAsset): asset is ICashAsset {
  return asset.idAssetType === IAssetTypeId.Cash;
}

export const CashAssetDataSchema = z.object({
  amount: z.number(), // approximate value in euro for foreign currency
  assetLocation: AssetLocationSchema,
  notes: z.string().optional(),
});

export const CashAssetSchema = GenericAssetSchema(
  z.literal(IAssetTypeId.Cash),
  z.literal(IAssetCategoryId.PersonalProperty),
  z.literal(CashAssetVersion.Initial).optional(),
  CashAssetDataSchema
);

export type ICashAsset = z.infer<typeof CashAssetSchema>;
